/* tslint:disable */
/* eslint-disable */
/**
 * topi Seller API
 * # Localization  Strings returned can be localized when the _Accept-Language_ header is provided in the request. It should follow the [RFC-2616 convention](http://www.ietf.org/rfc/rfc2616.txt).
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ExtraProductDetails interface.
 */
export function instanceOfExtraProductDetails(value) {
    let isInstance = true;
    isInstance = isInstance && "property" in value;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
export function ExtraProductDetailsFromJSON(json) {
    return ExtraProductDetailsFromJSONTyped(json, false);
}
export function ExtraProductDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'property': json['property'],
        'value': json['value'],
    };
}
export function ExtraProductDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'property': value.property,
        'value': value.value,
    };
}
